import React, { useMemo } from "react";
import { Provider, useSelector } from "react-redux";
import ShortsPlayer from "./shorts-player";
import createStore from "../../redux/createStore";
import Upgrade from "../upgrade/upgrade";
import SupportForm from "../upgrade/supportForm";
import FeedbackModal from "../../publish/feedback-modal";

/**
 * Component to create seperate store for each player.
 * @param {params: string, projectDetails: object, userDetails: object, shortData: object} props
 * @returns
 */
const ShortsWrapper = (props) => {
  const newStore = useMemo(() => createStore(true), []);
  const appReducer = useSelector((state) => state.app);
  const feedbackModal = appReducer.get("feedbackModal");
  const showFeedbackModal = feedbackModal.get("show");

  return (
    <Provider store={newStore}>
      <ShortsPlayer {...props} />
      <Upgrade />
      <SupportForm />
      <FeedbackModal
        showModal={showFeedbackModal}
      />
    </Provider>
  );
};

export default ShortsWrapper;
